export const GET_FRIENDLY_MATCHES = "GET_FRIENDLY_MATCHES"
export const GET_FRIENDLY_MATCHES_SUCCESS = "GET_FRIENDLY_MATCHES_SUCCESS"
export const GET_FRIENDLY_MATCH = "GET_FRIENDLY_MATCH"
export const GET_FRIENDLY_MATCH_SUCCESS = "GET_FRIENDLY_MATCH_SUCCESS"

export const API_ERROR = "FRIENDLY_MATCHES_API_ERROR"
